import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { defaultStorage, sessionStorage, type KeyValueStorageInterface } from 'aws-amplify/utils'

export type AuthScope = 'admin' | 'consumer'

const CONSUMER_CONFIRM_ORDER_ROUTE_PREFIX = '/consumer/confirm-order'

const authStorageByScope: Record<AuthScope, KeyValueStorageInterface> = {
    admin: defaultStorage,
    consumer: sessionStorage
}

const authConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID || '',
            userPoolClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID || ''
        }
    }
}

let isAuthInitialized = false
let activeAuthScope: AuthScope | null = null

export const initializeAuth = () => {
    if (isAuthInitialized) {
        return
    }

    if (!process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID || !process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID) {
        console.warn('[Auth] Missing Cognito env vars — authentication will not work.')
    }

    Amplify.configure(authConfig)
    isAuthInitialized = true
}

export const resolveAuthScope = (pathname: string): AuthScope => {
    return pathname.startsWith(CONSUMER_CONFIRM_ORDER_ROUTE_PREFIX) ? 'consumer' : 'admin'
}

// NOTE: activeAuthScope is global mutable state. applyAuthScope() switches storage
// synchronously, but fetchAuthSession() in api.ts is async. If two async call chains
// with different scopes overlap in the same JS event loop tick, the wrong tokens could
// be attached. This is safe under current single-tab, sequential UX flows. A proper fix
// would require a per-scope fetch layer or a mutex around scope switches.
export const applyAuthScope = (scope: AuthScope) => {
    initializeAuth()

    if (activeAuthScope === scope) {
        return
    }

    cognitoUserPoolsTokenProvider.setKeyValueStorage(authStorageByScope[scope])
    activeAuthScope = scope
}

export const initializeAuthForCurrentRoute = (pathname: string) => {
    const scope = resolveAuthScope(pathname)
    applyAuthScope(scope)
    return scope
}
